var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_vm._v(" "+_vm._s(_vm.query)+" "),_c('v-text-field',{attrs:{"name":this.name,"outlined":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }